<template>
	<div class="coupon-page">

		<!-- ===== 主卡片 ===== -->
		<div class="main-card animate__animated  ">

			<!-- Tab 栏 -->
			<div class="tab-row">
				<div class="tab-bar">
					<div
						v-for="(tab, idx) in mainTabs"
						:key="idx"
						class="tab-item"
						:class="{ 'tab-active': activeMainTab === idx }"
						@click="activeMainTabChange(idx)">
						{{ tab }}
					</div>
				</div>
				<!-- <div class="tab-divider"></div>
				<div class="sub-tab-bar" v-if="activeMainTab==0">
					<div
						v-for="(sub, idx) in types"
						:key="idx"
						class="sub-tab"
						:class="{ 'sub-tab-active': typesTab === idx }"
						@click="typesTab = idx">
						{{ sub }}
					</div>
				</div> -->
				<div class="sub-tab-bar" v-if="activeMainTab==0">
					<div
						v-for="(sub, idx) in subTabs"
						:key="idx"
						class="sub-tab"
						:class="{ 'sub-tab-active': activeSubTab === idx }"
						@click="activeSubTabF(idx)">
						{{ sub }}
					</div>
				</div>
			</div>
			
			
			<!-- 用户部分 -->
			<template v-if="activeMainTab==0">
			<!-- 运费加补券 -->
			<div class="coupon-section">
				<h3 class="section-title">运费优惠券</h3>
				<div class="coupon-row">
					<div class="zwBox" v-if="!freightCoupons.length">
						<el-image :src="require('@/static/zw.svg')"></el-image>
						<p>暂无相关信息...</p>
					</div>
					<div
						v-for="(item, idx) in freightCoupons"
						:key="'f' + idx"
						class="coupon-card"
						:class="activeMainTab==0&&activeSubTab==2?'hui':''"
						:style="{ backgroundImage: 'url(' + bg + ')' }">
						<div class="coupon-left">
							<div class="coupon-price-area" v-if="item.freightCoupon.couponType==1">
								<span class="price-currency price-currency1">¥</span>
								<span class="price-value">{{ item.freightCoupon.discount }}</span>
							</div>
							<div class="coupon-price-area" v-if="item.freightCoupon.couponType==2">
								<span class="price-value">{{ item.freightCoupon.discount }}</span>
								<span class="price-currency">折</span>
							</div>
							<div class="coupon-condition">{{item.freightCoupon.min?'满'+(item.freightCoupon.min)+'可用':'无门槛'}}</div>
						</div>
						<el-image class="coupon-divider" :src="divider"></el-image>
						<div class="coupon-info">
							<span class="coupon-name">{{ item.freightCoupon.name }}</span>
							<template v-if="item.freightCoupon.timeType==1">
							<span class="coupon-date">有效期始：{{ item.freightCoupon.startTime }}</span>
							<span class="coupon-date">有效期始：{{ item.freightCoupon.endTime }}</span>
							</template>
							<template v-else>
							<span class="coupon-date">有效期：{{ item.freightCoupon.days }}天</span>
							</template>
						</div>
						<div class="coupon-action" v-if="activeMainTab==0&&activeSubTab==0">
							<span class="action-text">立即使用</span>
						</div>
						<el-image class="pimg" v-if="activeMainTab==0&&activeSubTab==1" :src="require('@/static/add2/56.png')"></el-image>
						<el-image class="pimg" v-if="activeMainTab==0&&activeSubTab==2" :src="require('@/static/add2/57.png')"></el-image>
					</div>
				</div>
			</div>
			<!-- 代购加补券 -->
			<div class="coupon-section">
				<h3 class="section-title">代购优惠券</h3>
				<div class="coupon-row">
					<div class="zwBox" v-if="!purchaseCoupons.length">
						<el-image :src="require('@/static/zw.svg')"></el-image>
						<p>暂无相关信息...</p>
					</div>
					<div
						v-for="(item, idx) in purchaseCoupons"
						:key="'p' + idx"
						class="coupon-card"
						:class="activeMainTab==0&&activeSubTab==2?'hui':''"
						:style="{ backgroundImage: 'url(' + bg + ')' }">
						<div class="coupon-left">
							<div class="coupon-price-area" v-if="item.coupon.couponType==1">
								<span class="price-currency price-currency1">¥</span>
								<span class="price-value">{{ item.coupon.discount }}</span>
							</div>
							<div class="coupon-price-area" v-if="item.coupon.couponType==2">
								<span class="price-value">{{ item.coupon.discount }}</span>
								<span class="price-currency">折</span>
							</div>
							<div class="coupon-condition">{{item.coupon.min?'满'+(item.coupon.min)+'可用':'无门槛'}}</div>
						</div>
						<el-image class="coupon-divider" :src="divider"></el-image>
						<div class="coupon-info">
							<span class="coupon-name">{{ item.coupon.name }}</span>
							<template v-if="item.coupon.timeType==1">
							<span class="coupon-date">有效期始：{{ item.coupon.startTime }}</span>
							<span class="coupon-date">有效期始：{{ item.coupon.endTime }}</span>
							</template>
							<template v-else>
							<span class="coupon-date">有效期：{{ item.coupon.days }}天</span>
							</template>
						</div>
						<div class="coupon-action" v-if="activeMainTab==0&&activeSubTab==0">
							<span class="action-text">立即使用</span>
						</div>
						<el-image class="pimg" v-if="activeMainTab==0&&activeSubTab==1" :src="require('@/static/add2/56.png')"></el-image>
						<el-image class="pimg" v-if="activeMainTab==0&&activeSubTab==2" :src="require('@/static/add2/57.png')"></el-image>
					</div>
				</div>
			</div>
			</template>
			
			
			<!-- 领取部分 -->
			<template v-if="activeMainTab==1">
			<!-- 运费加补券 -->
			<div class="coupon-section">
				<h3 class="section-title">运费优惠券</h3>
				<div class="coupon-row">
					<div class="zwBox" v-if="!freightCoupons.length">
						<el-image :src="require('@/static/zw.svg')"></el-image>
						<p>暂无相关信息...</p>
					</div>
					<div
						v-for="(item, idx) in freightCoupons"
						:key="'f' + idx"
						class="coupon-card"
						:style="{ backgroundImage: 'url(' + bg + ')' }">
						<div class="coupon-left">
							<div class="coupon-price-area" v-if="item.couponType==1">
								<span class="price-currency price-currency1">¥</span>
								<span class="price-value">{{ item.discount }}</span>
							</div>
							<div class="coupon-price-area" v-if="item.couponType==2">
								<span class="price-value">{{ item.discount }}</span>
								<span class="price-currency">折</span>
							</div>
							<div class="coupon-condition">{{item.min?'满'+(item.min)+'可用':'无门槛'}}</div>
						</div>
						<el-image class="coupon-divider" :src="divider"></el-image>
						<div class="coupon-info">
							<span class="coupon-name">{{ item.name }}</span>
							<template v-if="item.timeType==1">
							<span class="coupon-date">有效期始：{{ item.startTime }}</span>
							<span class="coupon-date">有效期始：{{ item.endTime }}</span>
							</template>
							<template v-else>
							<span class="coupon-date">有效期：{{ item.days }}天</span>
							</template>
						</div>
						<div class="coupon-action" v-if="activeMainTab==1">
							<span class="action-text" @click="receiveFreight(item,idx)">立即领取</span>
						</div>
					</div>
				</div>
			</div>
			<!-- 代购加补券 -->
			<div class="coupon-section">
				<h3 class="section-title">代购优惠券</h3>
				<div class="coupon-row">
					<div class="zwBox" v-if="!purchaseCoupons.length">
						<el-image :src="require('@/static/zw.svg')"></el-image>
						<p>暂无相关信息...</p>
					</div>
					<div
						v-for="(item, idx) in purchaseCoupons"
						:key="'p' + idx"
						class="coupon-card"
						:style="{ backgroundImage: 'url(' + bg + ')' }">
						<div class="coupon-left">
							<div class="coupon-price-area" v-if="item.couponType==1">
								<span class="price-currency price-currency1">¥</span>
								<span class="price-value">{{ item.discount }}</span>
							</div>
							<div class="coupon-price-area" v-if="item.couponType==2">
								<span class="price-value">{{ item.discount }}</span>
								<span class="price-currency">折</span>
							</div>
							<div class="coupon-condition">{{item.min?'满'+(item.min)+'可用':'无门槛'}}</div>
						</div>
						<el-image class="coupon-divider" :src="divider"></el-image>
						<div class="coupon-info">
							<span class="coupon-name">{{ item.name }}</span>
							<template v-if="item.timeType==1">
							<span class="coupon-date">有效期始：{{ item.startTime }}</span>
							<span class="coupon-date">有效期始：{{ item.endTime }}</span>
							</template>
							<template v-else>
							<span class="coupon-date">有效期：{{ item.days }}天</span>
							</template>
						</div>
						<div class="coupon-action" v-if="activeMainTab==1">
							<span class="action-text" @click="receivePurchase(item,idx)">立即领取</span>
						</div>
					</div>
				</div>
			</div>
			</template>

		</div>
	</div>
</template>

<script>
import { 
	freightCouponReceive, 
	couponReceive,
	freightCouponAvailable,
	couponAvailable,
	couponmyCoupon,
	freightCouponmyCoupon
} from "/src/api/api.js"
export default {
	name: 'MyCoupon',
	data() {
		return {
			currentPage: 1,
			pageSize: 10,
			total: 30,
			// 选选项卡
			activeMainTab: 0,
			// typesTab: 0,
			activeSubTab: 0,
			mainTabs: ['我的优惠券', '优惠券中心'],
			// types: ['运费', '代购'],
			subTabs: ['待使用', '已使用', '已过期'],
			// 其他
			couponBase: '@/static/CodeBuddyAssets/30870_4636',
			bg: require('@/static/CodeBuddyAssets/30870_4636/24.svg'),
			divider: require('@/static/CodeBuddyAssets/30870_4636/25.svg'),
			freightCoupons: [],
			purchaseCoupons: [],
			// 优惠券选择弹窗
			couponModalVisible: false,
			selectedCoupon: null,
			tempSelCoupon: null,
			couponCloseIcon: require('@/static/sel/20.svg'),
			// 可选择的优惠券列表（从可用券中过滤）
			availableCoupons: [
				{
					id: 36,
					memberId: 4,
					couponId: 4,
					status: 0,
					usedTime: null,
					startTime: "2026.07.13",
					endTime: "2030.07.17",
					orderSn: null,
					orderId: null,
					version: 1,
					sortOrder: 0,
					createTime: "2026-08-06 15:13:56",
					updateTime: null,
					deleted: 0,
					userName: null,
					phonenumber: null,
					coupon: {
						id: 4,
						couponType: 2,
						name: "测试",
						introduce: "",
						tag: "",
						total: 0,
						discount: 9,
						min: 10,
						quantity: 1,
						type: 0,
						status: 0,
						code: null,
						timeType: 1,
						days: 0,
						startTime: "2026.07.13",
						endTime: "2030.07.17",
						sortOrder: 0,
						createTime: "2026-07-29 11:26:53",
						updateTime: null,
						deleted: 0,
						receivedNum: null,
						usedNum: null,
						unusedNum: null
					}
				}
			],
		}
	},
	mounted() {
		this.mygetListYf()
		this.mygetListDg()
	},
	methods: {
		// 优惠券列表 我的 运费
		async mygetListYf(){
			const res = await freightCouponmyCoupon({status: this.activeSubTab})
			if (res.code == 200) {
				this.freightCoupons = res.rows
			} else {this.Tips(res.msg)}
		},
		// 优惠券列表 我的 代购
		async mygetListDg(){
			const res = await couponmyCoupon({status: this.activeSubTab})
			if (res.code == 200) {
				this.purchaseCoupons = res.rows
			} else {this.Tips(res.msg)}
		},
		// 优惠券列表 可领取 运费
		async getListYf(){
			const res = await freightCouponAvailable({})
			if (res.code == 200) {
				this.freightCoupons = res.rows
			} else {this.Tips(res.msg)}
		},
		// 优惠券列表 可领取 代购
		async getListDg(){
			const res = await couponAvailable({})
			if (res.code == 200) {
				this.purchaseCoupons = res.rows
			} else {this.Tips(res.msg)}
		},
		// 领取运费券
		async receiveFreight(item, idx) {
			const res = await freightCouponReceive({ freightCouponId: item.id })
			if (res.code == 200) {
				this.Tips(res.msg || '领取成功')
				this.getListYf()
			} else {
				this.Tips(res.msg || '领取失败', 'error')
			}
		},
		// 领取代购券
		async receivePurchase(item, idx) {
			const res = await couponReceive({ couponId: item.id })
			if (res.code == 200) {
				this.Tips(res.msg || '领取成功')
				this.getListDg()
			} else {
				this.Tips(res.msg || '领取失败', 'error')
			}
		},
		// 切换选显卡
		activeMainTabChange(idx){
			this.freightCoupons = []
			this.purchaseCoupons = []
			this.activeMainTab = idx
			if(idx==1){
				this.getListYf()
				this.getListDg()
			}else{
				this.mygetListYf()
				this.mygetListDg()
			}
		},
		activeSubTabF(idx){
			this.freightCoupons = []
			this.purchaseCoupons = []
			this.activeSubTab = idx
			this.mygetListYf()
			this.mygetListDg()
		}
	},
}
</script>

<style lang="scss" scoped>
.coupon-page {
	width: 100%;
	box-sizing: border-box;
}

/* ===================================================================
   面包屑导航
   =================================================================== */
.breadcrumb {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 22px;
	margin-bottom: 24px;
}
.breadcrumb-inner {
	display: flex;
	align-items: center;
}
.crumb-label {
	font-size: 16px;
	color: #333;
	font-weight: 400;
}
.crumb-text {
	font-size: 16px;
	color: #666;
	font-weight: 400;
	margin-left: 8px;
}
.back-btn {
	display: flex;
	align-items: center;
	cursor: pointer;
	span {
		font-size: 16px;
		font-weight: 400;
		color: #0096FF;
	}
	.back-icon {
		width: 8px;
		height: 12px;
		margin-left: 6px;
	}
}

/* ===================================================================
   主卡片 (1596×455px)
   =================================================================== */
.main-card {
	width: 1596px;
	background: #fff;
	border-radius: 12px;
	padding: 24px;
	box-sizing: border-box;
	margin-top: 24px;
}

/* ---- Tab 栏 ---- */
.tab-row {
	margin-bottom: 24px;
}
.tab-bar {
	display: flex;
	align-items: center;
	// height: 22px;
}
.tab-item {
	font-size: 18px;
	color: #7D7D89;
	font-weight: 400;
	cursor: pointer;
	margin-right: 32px;
	transition: 0.3s;
	position: relative;
	padding-bottom: 16px;
	&::after{
		content: '';
		position: absolute;
		width: 0px;
		height: 4px;
		border-radius: 4px;
		background: #0096FF;
		left: 50%;
		transform: translateX(-50%);
		bottom: 0;
		transition: 0.3s;
	}
}
.tab-item.tab-active {
	color: #0096FF;
	font-weight: 500;
	&::after{
		content: '';
		position: absolute;
		width: 72px;
		height: 4px;
		border-radius: 4px;
		background: #0096FF;
		left: 50%;
		transform: translateX(-50%);
		bottom: 0;
		transition: 0.3s;
	}
}

.tab-divider {
	width: 1548px;
	height: 1px;
	background: #F0F0F0;
}

/* ---- 子 Tab ---- */
.sub-tab-bar {
	display: flex;
	align-items: center;
	position: relative;
	margin-top: 16px;
	height: 22px;
}
.sub-tab {
	font-size: 14px;
	color: #666;
	font-weight: 400;
	cursor: pointer;
	margin-right: 36px;
	white-space: nowrap;
	transition: color 0.3s;
}
.sub-tab:last-child {
	margin-right: 0;
}
.sub-tab.sub-tab-active {
	color: #0096FF;
}
.sub-indicator {
	position: absolute;
	bottom: -16px;
	width: 72px;
	height: 4px;
	background: #0096FF;
	border-radius: 10px;
	transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* ===================================================================
   优惠券区域
   =================================================================== */
.coupon-section {
	margin-bottom: 24px;
}
.coupon-section:last-of-type {
	margin-bottom: 0;
}
.section-title {
	font-size: 18px;
	font-weight: 500;
	color: #333;
	margin: 0 0 16px;
}

.coupon-row {
	display: flex;
	flex-wrap: wrap;
}

/* ---- 优惠券卡片 (343×93px) ---- */
.coupon-card {
	width: 343px;
	height: 93px;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	border-radius: 8px;
	display: flex;
	align-items: center;
	box-sizing: border-box;
	overflow: hidden;
	margin-right: 32px;
	margin-bottom: 16px;
	flex-shrink: 0;
	position: relative;
	.pimg{
		position: absolute;
		width: 69px;
		height: 69px;
		right: 10px;
		top: 50%;
		transform: translateY(-50%);
	}
}

.coupon-left {
	width: 109px;
	height: 93px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.coupon-price-area {
	display: flex;
	align-items: baseline;
	justify-content: center;
}
.price-currency {
	font-size: 16px;
	color: #FC3C3C;
	font-weight: 400;
}
.price-currency1{
	transform: translateX(-4px)translateY(-4px);
}
.price-value {
	font-size: 36px;
	color: #FC3C3C;
	font-weight: 400;
}
.coupon-condition {
	width: 73px;
	height: 24px;
	background: #fff;
	border-radius: 5px;
	text-align: center;
	line-height: 24px;
	font-size: 12px;
	color: #FC3C3C;
	font-weight: 400;
	// margin-top: 4px;
}

.coupon-divider {
	width: 4px;
	height: 71px;
	flex-shrink: 0;
	margin-right: 12px;
}

.coupon-info {
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
}
.coupon-name {
	font-size: 16px;
	color: #333;
	font-weight: 400;
	margin-bottom: 4px;
}
.coupon-date {
	font-size: 12px;
	color: #666;
	font-weight: 400;
	margin-bottom: 2px;
}
.coupon-date:last-child {
	margin-bottom: 0;
}

.coupon-action {
	width: 48px;
	height: 93px;
	background: #FC3C3C;
	border-top-right-radius: 12px;
	border-bottom-right-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}
.action-text {
	font-size: 12px;
	color: #fff;
	font-weight: 500;
	text-align: center;
	letter-spacing: 4px;
	
	// line-height: 45px;
	writing-mode: vertical-rl;
}

/* ===================================================================
   分页
   =================================================================== */
.pagination-wrap {
	display: flex;
	justify-content: center;
	margin-top: 30px;
}
.pagination-wrap ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
	background-color: #0096FF;
}
.pagination-wrap ::v-deep .el-pagination.is-background .el-pager li:hover {
	color: #0096FF;
}

.hui{
	filter: grayscale(100%);
}
</style>
